import SimpleDecorator from 'draft-js-simpledecorator';

import Link from '../../../components/Link';
import findLinkEntitiesStrategy from './findLinkEntitiesStrategy';

/**
 * Must be called with `this` bound to TextBlock.
 */
export default function createLinkDecorator() {
  return new SimpleDecorator(findLinkEntitiesStrategy.bind(this), Link);
}
